export const horseExamQueryKeys = {
  all: (): string => "horse-exam",
  inProgressList: (
    horseId?: string,
    vetId?: string,
    facilityId?: string
  ): string =>
    `horse-exam:list:in-progress:${horseId}:${vetId}:${facilityId || "all"}`,
  completedList: (horseId?: string): string =>
    `horse-exam:list:completed:${horseId}`
};
